var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['browser_' + _vm.browser],attrs:{"id":"app"}},[(!_vm.appOutDated)?[_c('Loader'),_c('FixedInfo'),_c('EmojiSetSprite'),(!_vm.playerNameSaved)?_c('SaveNameScreen'):_c('router-view')]:_c('UpdateRequired')],2)}
var staticRenderFns = []

export { render, staticRenderFns }